/*
 * Setup Page Messages
 *
 * This contains all the text for the Setup Page component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.SetupPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Setup',
  },
  tutorialDeleted: {
    id: `${scope}.tutorialDeleted`,
    defaultMessage: 'Tutorial deleted successfully',
  },
  fieldCategoryDeleted: {
    id: `${scope}.fieldCategoryDeleted`,
    defaultMessage: 'Field category deleted successfully',
  },
  tutorialSaved: {
    id: `${scope}.tutorialSaved`,
    defaultMessage: 'Tutorial saved successfully',
  },
  fieldCategorySaved: {
    id: `${scope}.fieldCategorySaved`,
    defaultMessage: 'Category saved successfully',
  },
});
